import { render, staticRenderFns } from "./mahjongPhoenix.vue?vue&type=template&id=5434301e&scoped=true"
import script from "./mahjongPhoenix.vue?vue&type=script&lang=js"
export * from "./mahjongPhoenix.vue?vue&type=script&lang=js"
import style0 from "./mahjongPhoenix.vue?vue&type=style&index=0&id=5434301e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434301e",
  null
  
)

export default component.exports